const REVIEW_CONSTANTS = {
  TEXT_LENGTH_LIMIT: 250,
  DEFAULT_PER_PAGE: 6,
  DEFAULT_PAGE: 1,
};

export default REVIEW_CONSTANTS;
